import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { Environment } from 'src/environments/environment.model';

import { EnvironmentalImpactDelivery, EnvironmentalImpactWithBenchmark } from '../environmental-impact.models';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentalImpactService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.APIM_BASE_URL + '/environmental-metric-service';

  fetchEnvironmentalImpactReportWithBenchmark(
    cropYear: number,
    cropFieldId: number,
  ): Observable<EnvironmentalImpactWithBenchmark> {
    return this.http.get<EnvironmentalImpactWithBenchmark>(
      `${this.baseUrl}/environmental-impact/benchmark/${cropYear}/${cropFieldId}`,
    );
  }

  fetchEnvironmentalImpactDeliveries(year: number): Observable<EnvironmentalImpactDelivery> {
    return this.http.get<EnvironmentalImpactDelivery>(
      `${this.baseUrl}/environmental-impact/deliveries/${year}`,
    );
  }
}
